<div class='left-menu' style="width:100%">
    <ul class='nav navbar-nav'>
        <li>
            <controller-type (controllerChanged)="onControllerChanged($event)"></controller-type>
        </li>
    </ul>
</div>